import React, { useState, useEffect } from 'react';

const APP_KEY = 'APP_UNLOCKED';
const ADMIN_KEY = 'ADMIN_PASSWORD';

export default function AppGate({ children }) {
  const [unlocked, setUnlocked] = useState(false);
  const [pw, setPw] = useState('');

  useEffect(() => {
    // already unlocked?
    if (localStorage.getItem(APP_KEY) === 'yes') setUnlocked(true);
  }, []);

  const submit = (e) => {
    e.preventDefault();
    const need = 'bulk-Delete.64f2';
    if (!need) {
      alert('App password not configured.');
      return;
    }
    if (pw.trim() === need) {
      // Unlock the UI
      localStorage.setItem(APP_KEY, 'yes');
      setUnlocked(true);
      // Also store the same password for API writes if you like (matches server ADMIN_PASSWORD)
      localStorage.setItem(ADMIN_KEY, pw.trim());
    } else {
      alert('Wrong password');
    }
  };

  if (!unlocked) {
    return (
      <div style={{
        minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
        background:'#0f172a'
      }}>
        <form onSubmit={submit} style={{
          width: 360, background:'#fff', padding:'24px', borderRadius:12,
          boxShadow:'0 10px 30px rgba(0,0,0,0.15)'
        }}>
          <div style={{textAlign:'center', marginBottom:12, fontWeight:600, fontSize:18}}>
            Salankaraa Admin
          </div>
          <label style={{display:'block', fontSize:13, color:'#475569', marginBottom:6}}>
            Enter password
          </label>
          <input
            type="password"
            value={pw}
            onChange={(e)=>setPw(e.target.value)}
            placeholder="Password"
            style={{
              width:'100%', padding:'10px 12px', border:'1px solid #cbd5e1',
              borderRadius:8, outline:'none'
            }}
          />
          <button type="submit" style={{
            marginTop:12, width:'100%', padding:'10px 12px',
            background:'#4f46e5', color:'#fff', border:'none', borderRadius:8,
            fontWeight:600, cursor:'pointer'
          }}>
            Enter
          </button>
          <div style={{marginTop:10, fontSize:12, color:'#64748b', textAlign:'center'}}>
            app.salankaraa.com
          </div>
        </form>
      </div>
    );
  }

  return children;
}